import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { useTranslation } from "react-i18next";
import "./css/Modal.scss";
import PrintIcon from "@material-ui/icons/Print";

export interface IPaymentModalProps {
    success: boolean;
    paymentRef: string;
    prospectId: string;
    file: {
        name: string;
        base64File: string;
    };
    isModalOpen: boolean;
    onConfirm(): void;
}

export const PaymentModal = (props: IPaymentModalProps) => {
    const { t } = useTranslation("payment");
    const { success, paymentRef, prospectId, file, isModalOpen, onConfirm } = props;

    const b64toBlob = (b64Data: any, contentType: string, sliceSize: number) => {
        contentType = contentType || "image/png";
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    };

    const downloadFile = () => {
        var downloadLink = document.createElement("a");
        downloadLink.target = "_blank";
        downloadLink.download = file?.name || "PaymentReceipt.pdf";

        // create an object URL from the Blob
        var URL = window.URL || window.webkitURL;
        // convert base64 data to a Blob
        var downloadUrl = URL.createObjectURL(b64toBlob(file?.base64File, "application/pdf", 512));

        // set object URL as the anchor's href
        downloadLink.href = downloadUrl;

        // append the anchor to document body
        document.body.append(downloadLink);

        // fire a click event on the anchor
        downloadLink.click();

        // cleanup: remove element and revoke object URL
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(downloadUrl);
    };

    return (
        <Dialog maxWidth="md" open={isModalOpen}>
            {/* <Grid className="dialog-close" container justify="flex-end">
                <Grid className="dialog-close__icon" item>
                    <IconButton aria-label="close" onClick={close}>
                        <CloseIcon style={{ color: "#ffffff" }} />
                    </IconButton>
                </Grid>
            </Grid> */}
            <DialogTitle disableTypography style={{ backgroundColor: "#4a148c" }}>
                <Grid container justify="center">
                    <Grid item sm={12} xs={6}>
                        <Typography align="center" style={{ color: "#ffffff" }} variant="h3">
                            {success ? t("paymentSuccess") : t("paymentFailed")}
                        </Typography>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent>
                {success ? (
                    <Grid container direction="column" justify="center" alignItems="center">
                        <Typography color="inherit" variant="body1">
                            {t("thankYou")}
                        </Typography>
                        <Typography color="inherit" variant="body1">
                            {t("workingOrder")}
                        </Typography>
                        <Grid container direction="row" spacing={2} justify="center" alignItems="center">
                            <Grid item>
                                <Typography color="secondary" variant="subtitle1">
                                    {t("accountNumber")}: {prospectId}
                                </Typography>
                                <Typography color="secondary" variant="subtitle1">
                                    {t("paymentRef")}: {paymentRef}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <IconButton
                                    aria-label="Print"
                                    className="printIcon"
                                    onClick={() => {
                                        downloadFile();
                                    }}
                                >
                                    <PrintIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Grid>
                ) : (
                    <Typography align="center" variant="body1">
                        {t("paymentFailedMessage")}
                    </Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Grid container justify="center">
                    <Grid item md={2} sm={3} xs={6}>
                        <Button
                            className="xtest_modal_confirm_button"
                            color="secondary"
                            fullWidth
                            size="large"
                            variant="contained"
                            onClick={() => onConfirm()}
                        >
                            {success ? t("close") : t("retry")}
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    );
};
